export default {
  methods: {
    gettext: function(msgid) {
      return window["gettext"](msgid);
    }
  }
};
